import {RequestState} from "../../requestState";
import vue from "vue";

export function getInvoiceInfoById(state) {
  return invoiceId => {
    return state.invoices.items[invoiceId]
  };
}

export function getInvoiceLogCandidatesSection(state) {
  return invoiceId => {
    let result = state.invoices.logsByInvoices[invoiceId];

    if (!result) {
      result = {
        filter: {
          dateRange: null, // DateRange
          metaFilters: [],
          logMode: 'FromInvoiceOrDateRange',
          caseAnomalyFilter: 'All',
          pagination: {
            page: 1,
            rowsPerPage: 50
          },
        },
        clientFilter: {
          caseAnomalies: [],
          executedPriceOver9000: false
        },
        requestState: RequestState.NotPerformed,
        response: {}
      };

      vue.set(state.invoices.logsByInvoices, invoiceId, result);
    }
    return result;
  };
}



// WEBPACK FOOTER //
// ./src/store/getters/invoices.js